module.exports = {
  language: {
    name: 'English'
  },
  header: {
    lang: '中文版',
    home: 'HOME',
    product: 'PRODUCT',
    video: 'VIDEO',
    news: 'NEWS',
    about: 'ABOUT',
    search: 'search',
    langageimg: "cn.png",
  },
  footer: {
    lang: '中文版',
    home: 'HOME',
    product: 'PRODUCT',
    video: 'VIDEO',
    news: 'NEWS',
    about: 'ABOUT',
    concact: 'Address：QI GAO LE TOYS, Shantou, Guangdong Province　|　Phone:0754-85892999　QQ：2625317429　mobile：17722135999　Contact：Mr.Zheng',
    power: 'Copyright QIGAOLETOYS 2022-2030 All Right Reserved ',
    address: 'Record <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备18053044号-2</a>',
  }
}



// WEBPACK FOOTER //
// ./src/components/language/en.js